interface Plan {
  name: string;
  price: string;
  period: string;
  desc: string;
  features: string[];
  cta: string;
  featured?: boolean;
}

const PLANS: Plan[] = [
  {
    name: "Starter",
    price: "49",
    period: "/ miesiąc",
    desc: "Praktyka z AI lektorem na start — bez lekcji z człowiekiem.",
    features: [
      "2 × 25 min sesji z AI lektorem",
      "Scoring po każdej sesji",
      "Raport postępu po każdej sesji",
      "Mobile + desktop",
    ],
    cta: "Wybierz Starter",
  },
  {
    name: "Pro",
    price: "149",
    period: "/ miesiąc",
    desc: "Lekcja z prawdziwym lektorem + praktyka z AI awatarem.",
    features: [
      "1 lekcja 60 min z certyfikowanym lektorem",
      "2 × 30 min rozmowy z AI awatarem",
      "Personalny plan nauki",
      "Materiały i nagranie po lekcji",
      "Priorytet w grafiku",
    ],
    cta: "Wybierz Pro",
    featured: true,
  },
  {
    name: "Premium",
    price: "350",
    period: "/ miesiąc",
    desc: "Intensywny program — 3 lekcje z lektorem co miesiąc.",
    features: [
      "3 lekcje 60 min z certyfikowanym lektorem",
      "3 × 30 min z AI awatarem",
      "Certyfikat poziomu (CEFR)",
      "Lektor native speaker dostępny",
      "Dedykowany koordynator",
    ],
    cta: "Wybierz Premium",
  },
];

interface Props {
  onCta: () => void;
}

export function Pricing({ onCta }: Props): JSX.Element {
  return (
    <section id="pricing" className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <div className="text-xs text-lime-500 uppercase tracking-widest font-semibold mb-3">Cennik</div>
          <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight">
            Wybierz plan, <span className="text-lime-500">zacznij dziś</span>
          </h2>
          <p className="mt-4 text-ink-300 text-lg">
            Wszystkie zakresy w cyklu miesięcznym. Anuluj kiedy chcesz — bez umów na czas określony. Pierwsza lekcja zawsze za 0 zł.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {PLANS.map((p) => (
            <div
              key={p.name}
              className={
                p.featured
                  ? "relative bg-gradient-to-b from-lime-500/10 to-ink-800 border-2 border-lime-500 rounded-2xl p-7 md:scale-105 shadow-glow-lime"
                  : "bg-ink-800 border border-ink-700 rounded-2xl p-7"
              }
            >
              {p.featured && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-lime-500 text-ink-900 text-xs font-bold uppercase tracking-wider rounded-full px-3 py-1">
                  Najczęściej wybierany
                </div>
              )}
              <h3 className="text-xl font-bold text-white">{p.name}</h3>
              <p className="text-sm text-ink-300 mt-1 mb-5 min-h-[40px]">{p.desc}</p>
              <div className="flex items-baseline gap-1 mb-6">
                <span className="text-5xl font-bold text-white">{p.price}</span>
                <span className="text-ink-400 text-sm">PLN {p.period}</span>
              </div>
              <button
                onClick={onCta}
                className={
                  p.featured
                    ? "w-full bg-lime-500 hover:bg-lime-400 text-ink-900 font-semibold rounded-xl px-4 py-3 mb-6 transition"
                    : "w-full bg-ink-700 hover:bg-ink-600 text-white font-semibold rounded-xl px-4 py-3 mb-6 transition"
                }
              >
                {p.cta}
              </button>
              <ul className="space-y-2.5">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-ink-200">
                    <svg className="w-4 h-4 mt-0.5 text-lime-500 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clipRule="evenodd"/>
                    </svg>
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
